import React, {useEffect, useState} from "react";
import HSort from "../canopia/HSort";
import {findValueInArray, search2, sort} from "../canopia/CanopiaUtils";
import {FormGroup} from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import {TiDeleteOutline} from "react-icons/ti";
import {PageSelector} from "../core/PageSelector";
import NameTruncWithSearch from "../canopia/NameTruncWithSearch";
import SuperService from "../../services/super.service";
import MessageBox from "../core/MessageBox";

export default function CronConfigsList(props) {

    const tgtDataOrig = props.tgtDataOrig;
    const refreshFunc = props.refreshFunc;

    const initialSortStatus = {
        "alias": "asc",
        "name": "asc",
        "cron": "asc"
    }

    const SEARCH_PROPS = ["name"];

    const sortAndFilterInitialState = {
        sortStatus: initialSortStatus, sortCol: "name",
    }

    const [myState, setMyState] = useState({
        tgtData: tgtDataOrig, // The displayed ones, filtered, sorted, ...

        ...sortAndFilterInitialState
    });

    // Pagination
    const PAGE_SIZE = 50;
    const [page, setPage] = useState(1);

    // Search
    const [clearSearchVisibility, setClearSearchVisibility] = useState('hidden');
    const [searchString, setSearchString] = useState('');

    // Update cron
    const [crons, setCrons] = useState([]);
    const [updateStatus, setUpdateStatus] = useState("idle");
    const [errorName, setErrorName] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const colorClass = 'canopia2';
    const pfBgClass = 'background-light';
    const colSizeM = 300;
    const colWidthM = colSizeM + 'px';
    const colSizeL = 400;
    const colWidthL = colSizeL + 'px';
    const padding = '0.55em 0.5em';

    useEffect(() => {
        let newCrons = [];
        tgtDataOrig.map(config => {
            newCrons.push({alias: config.alias, cron: config.cron, defCron: config.cron});
        });
        setCrons(newCrons);
        filter(searchString);
    }, [tgtDataOrig]);

    function sortFunc(colName) {
        const newState = sort({...myState}, colName, initialSortStatus);
        setMyState(newState);
    }

    function changePage(page) {
        setPage(page.key);
    }

    function filter(searchString) {
        let newData = [...tgtDataOrig];

        if (searchString.trim() === "") {
            setClearSearchVisibility("hidden");
        } else {
            if (clearSearchVisibility === "hidden") {
                setClearSearchVisibility("visible");
            }
            newData = search2(searchString, newData, SEARCH_PROPS);
        }

        let newState = {...myState, tgtData: newData};

        newState = sort(newState, newState.sortCol, initialSortStatus, true);

        setMyState(newState);
    }

    // Search category, the component is common to the global and histo view
    const searchCategory = (e) => {
        let searchString = e.target.value;
        searchCat(searchString);
    }

    const resetSearch = () => {
        searchCat('');
    }

    function searchCat(searchString) {
        setSearchString(searchString);
        filter(searchString);
    }

    const changeCron = (e) => {
        let alias = e.target.name;
        let cron = e.target.value;
        let newCrons = [...crons];
        let configAndIdx = findValueInArray(newCrons, ["alias"], alias);
        if (configAndIdx) {
            let newCron = {alias: alias, cron: cron, defCron: configAndIdx.item.defCron};
            newCrons.splice(configAndIdx.index, 1, newCron);
            setCrons(newCrons);
        }
    }

    const save = (alias) => {

        // let inlineUserClients = inlineParams(selectedUserClients, "userClients");
        setUpdateStatus("pending");
        let configAndIdx = findValueInArray(crons, ["alias"], alias);
        SuperService.saveCronConfig(configAndIdx.item.alias, configAndIdx.item.cron).then(
            () => {
                // setUpdateStatus("success");
                refreshFunc();
            },
            error => {
                setUpdateStatus("error");
                processError(error);
            }
        );
    };

    const reset = (alias) => {
        let newCrons = [...crons];
        let configAndIdx = findValueInArray(newCrons, ["alias"], alias);
        if (configAndIdx) {
            let newCron = {alias: alias, cron: configAndIdx.item.defCron, defCron: configAndIdx.item.defCron};
            newCrons.splice(configAndIdx.index, 1, newCron);
            setCrons(newCrons);
        } else {
            // Should not happen
        }
    };

    const processError = (error) => {
        let response = error.response;

        let errorName;
        let errorMessage;
        if (response
            && response.data
            && response.data.error
            && response.data.message
        ) {
            errorName = response.data.error;
            errorMessage = response.data.message;
        } else {
            errorName = 'Service unavailable';
            errorMessage = 'We apologize for the inconvenience, our team is working on solving the issue. Please try to come back in a few minutes.\nThank you for your patience.';
            if (error.message) {
                console.log(error.message);
            }
        }

        setErrorName(errorName);
        setErrorMessage(errorMessage);
    }

    let searchCategoryInput = <FormGroup controlId="selectView">
        <input value={searchString}
               placeholder="Search client, date, ..."
               className={'form-control float-left'}
               style={{minWidth: "280px"}}
               aria-label="Search category"
               onChange={searchCategory}
               aria-describedby="basic-addon2"/>
    </FormGroup>;

    let searchCategoryComp;
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap", marginRight: 'auto'}}>
            {searchCategoryInput}
        </div>
    } else {
        searchCategoryComp = <div style={{display: "flex", flexWrap: "nowrap"}}>
            {searchCategoryInput}
            <Button variant="light" size="sm"
                    style={{
                        marginLeft: 0,
                        padding: 4,
                        borderWidth: '1px 1px 1px 0',
                        borderColor: '#ced4da',
                        borderRadius: '0.25rem .25rem .25rem 0.25rem',
                        visibility: clearSearchVisibility
                    }}
                    onClick={resetSearch}>
                <TiDeleteOutline size={"1.4em"} className={"canopia2"}/>
            </Button>
            {/*<span style={{paddingLeft: '10px', margin: 'auto'}}>{searchString.length > 0 ? searchCount + ' result(s)' : ''}</span>*/}
        </div>
    }

    let rows;
    let effPage = page;
    let tgtData = myState.tgtData;

    function getDiffNb(nb) {
        return <>({nb > 0 ? <>+{nb}</> : nb})</>;
    }

    if (tgtData && tgtData.length > 0) {

        let startIndex = (effPage - 1) * PAGE_SIZE;
        if (startIndex >= tgtData.length) {
            effPage = 1;
            startIndex = (effPage - 1) * PAGE_SIZE;
        }
        const tgtDataAtPage = tgtData.slice(startIndex, startIndex + PAGE_SIZE);
        rows = tgtDataAtPage.map(config => {

            let configAndIdx = findValueInArray(crons, ["alias"], config.alias);
            const showSave = configAndIdx ? configAndIdx.item.cron !== config.cron : false;
            const cron = configAndIdx ? configAndIdx.item.cron : config.cron;

            return <div key={config.alias} className={"flex-nowrap border-top setup-row"}>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    <NameTruncWithSearch name={config.name} maxSize={80} search={searchString} wrap={true}/>
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthM, padding: padding}}>
                    {config.alias}
                </div>
                <div className={"setup-col"} style={{flexBasis: colWidthL, padding: padding}}>
                    <input type={"text"}
                           className={'form-control float-left'}
                           style={{width: (colSizeM - 80) + "px"}}
                           aria-label="Search category"
                           onChange={changeCron}
                           value={cron}
                           name={config.alias}
                           aria-describedby="basic-addon2"/>
                    {showSave && (
                        <button
                            style={{marginLeft: '1rem'}}
                            className="btn btn-primary btn-block"
                            disabled={updateStatus === 'pending'}
                            onClick={() => save(config.alias)}
                        >
                            {updateStatus === 'pending' && (
                                <span className="spinner-border spinner-border-sm"/>
                            )}
                            <span>Save</span>
                        </button>
                    )}
                    {showSave && (
                        <button
                            style={{marginLeft: '1rem'}}
                            className="btn btn-primary btn-block"
                            disabled={updateStatus === 'pending'}
                            onClick={() => reset(config.alias)}
                        >
                            <span>Reset</span>
                        </button>
                    )}
                </div>
                <div className={"setup-col right"} style={{flexGrow: "1", padding: padding}}/>
            </div>;
        });
    }

    const pageSelector = <PageSelector page={effPage} pageSize={PAGE_SIZE} size={tgtData.length}
                                       clickFunc={changePage}/>;

    return (<>
        <div className={'border-top background-light'} style={{marginTop: "2rem"}}>
            {/*<div className={"flex-nowrap"}>*/}
            {/*    <div className={"setup-th"} style={{flexBasis: "250px"}}>*/}
            {/*        {pageSelector}*/}
            {/*    </div>*/}
            {/*    <div className={"setup-th-input"} style={{flexBasis: "250px"}}>*/}
            {/*        <div>{searchCategoryComp}</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className={'border-top background-light'}>
                <div className={"flex-nowrap"}>
                    <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>Name</b>} colName={'name'} state={myState} sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th"} style={{flexBasis: colWidthM}}>
                        <HSort label={<b>Alias</b>} colName={'alias'} state={myState} sortFunc={sortFunc}/>
                    </div>
                    <div className={"setup-th"} style={{flexBasis: colWidthL}}>
                        <HSort label={<b>Cron</b>} colName={'cron'} state={myState} sortFunc={sortFunc}/>
                    </div>
                </div>
            </div>
        </div>
        {rows}
        {errorName && (
            <MessageBox
                title={errorName}
                message={errorMessage}
                colorClass={'canopia6'}
                autoDismiss={10000}  // Auto-dismiss after 10 seconds
                onDismiss={() => {
                    setErrorMessage(null);
                    setErrorName(null)
                }}
            />
        )}
    </>);
}